import { TypographyOptions } from '@mui/material/styles/createTypography';
import breakpoints from './breakpoints';

const typography: TypographyOptions = {
  allVariants: {
    // allow breaking overly long words at any point, while respecting width:min-content - replacement for word-break
    overflowWrap: 'anywhere',
  },
  fontFamily: '"On Air", "Open Sans", sans-serif',
  htmlFontSize: 16,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  // sets global font-weight of <b>, <strong> tags
  fontWeightBold: 600,
  h1: {
    fontWeight: 600,
    fontSize: '1.75rem',
    lineHeight: 1.357142857,
    [`@media (min-width: ${breakpoints.md}px)`]: {
      fontSize: '1.875rem',
      lineHeight: 1.333333333,
    },
    [`@media (min-width: ${breakpoints.lg}px)`]: {
      fontSize: '2.0625rem',
      lineHeight: 1.303030303,
    },
  },
  h2: {
    fontWeight: 600,
    fontSize: '1.5625rem',
    lineHeight: 1.36,
    [`@media (min-width: ${breakpoints.md}px)`]: {
      fontSize: '1.6875rem',
      lineHeight: 1.333333333,
    },
    [`@media (min-width: ${breakpoints.lg}px)`]: {
      fontSize: '1.8125rem',
      lineHeight: 1.310344827,
    },
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.375rem',
    lineHeight: 1.409090909,
    [`@media (min-width: ${breakpoints.md}px)`]: {
      fontSize: '1.4375rem',
      lineHeight: 1.391304347,
    },
    [`@media (min-width: ${breakpoints.lg}px)`]: {
      fontSize: '1.625rem',
      lineHeight: 1.346153846,
    },
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.1875rem',
    lineHeight: 1.47368421,
    [`@media (min-width: ${breakpoints.md}px)`]: {
      fontSize: '1.3125rem',
      lineHeight: 1.428571428,
    },
    [`@media (min-width: ${breakpoints.lg}px)`]: {
      fontSize: '1.4375rem',
      lineHeight: 1.391304347,
    },
  },
  h5: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: 1.5,
    [`@media (min-width: ${breakpoints.md}px)`]: {
      fontSize: '1.125rem',
      lineHeight: 1.5,
    },
    [`@media (min-width: ${breakpoints.lg}px)`]: {
      fontSize: '1.25rem',
      lineHeight: 1.4,
    },
  },
  h6: {
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.571428571,
    [`@media (min-width: ${breakpoints.md}px)`]: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    [`@media (min-width: ${breakpoints.lg}px)`]: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
  },
  body1: {
    fontSize: '0.875rem', // This should be 14px
    lineHeight: 1.4285714, // This should be 20px
  },
  body2: {
    fontSize: '0.75rem', // 12px
    lineHeight: 1.4285714,
  },
  caption: {
    lineHeight: '16px',
  },
  button: {
    textTransform: 'none',
    fontSize: '0.875rem',
    fontWeight: 600,
  },
};

export default typography;
